export const toUrlId = (id = '') => {
  return id.replaceAll('#', '_')
}

export const fromUrlId = (id = '') => {
  return id.replaceAll('_', '#')
}
